<bic-popup [hasBackdrop]="true" customClass="w-[560px] h-[226px]" title="Verlassen ohne Speichern?">
  <div bicPopupContent class="flex flex-col">
    <span class="font-normal">Wollen Sie die Seite wirklich verlassen, ohne die Änderungen zu speichern?<br><br>
      Wählen Sie Verlassen um fortzufahren oder Abbrechen, um auf der aktuellen Seite zu bleiben.</span>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="discardClicked()" buttonType="primary">Verlassen</bic-button>
  </div>
</bic-popup>
